exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".advertisement-contents{margin:20px 0;padding:10px 0 20px}.advertisement-contents .advertisement-titles{width:60%;font-size:10px}.advertisement-contents .advertisement-figure{height:90px;width:60%;background-color:#6f6f6f}.advertisement-contents .advertisement-figure:hover{cursor:pointer;opacity:.8}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c3be3372","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ads/store-ads.vue
// module id = 89
// module chunks = 0